import React, { PureComponent, Suspense } from 'react';
import { BrowserRouter, Routes as RouterRoutes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { init as sentryInit } from '@sentry/browser';
import {
  ThemeProvider,
  createTheme, StyledEngineProvider, Theme,
} from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { withSSO } from '@sbgsports/vault-sso-auth';
import { ToastContainer } from 'react-toastify';
import TwitterTokenVerification from './NonProtected/TwitterTokenVerification/component';
import { toastContainerProps } from '../utils/toast';

import store from '../state/store';
import ApplicationLayout, { IProps } from '../layouts/ApplicationLayout';
import { getEnv } from '../utils';
import { Environment } from '../enums';
import { Routes, Colors } from '../constants';
import { enableMixPanel, initMixPanel } from '../utils/mixPanel';
import ProtectedRoute from '../utils/catapultxos/sso-auth/ProtectedRoute';
import ImpersonationBanner from './ImpersonationBanner/component';

declare module '@mui/styles/defaultTheme' {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme { }
}

const env = getEnv();

if (env !== Environment.Local) {
  // eslint-disable-next-line no-console
  console.log('Sentry initialized.');

  sentryInit({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: env,
  });
}

const theme = createTheme({
  palette: {
    primary: {
      main: Colors.PRIMARY,
    },
    secondary: {
      main: Colors.SECONDARY,
    },
  },
});

if (enableMixPanel()) {
  initMixPanel();
}
class App extends PureComponent {
  render() {
    return (
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={theme}>
            <Provider store={store}>
              <BrowserRouter
                basename="/"
                future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
              >
                <ToastContainer {...toastContainerProps} />
                {/* Above the routes so it stays visible on every screen for the
                    whole session, not just the one the admin started from */}
                <ImpersonationBanner />
                <RouterRoutes>
                  <Route
                    path={Routes.TWITTER_TOKEN_VERIFICATION}
                    element={<TwitterTokenVerification />}
                  />
                  <Route
                    path="/*"
                    element={(
                      <ProtectedRoute
                        loginURL={process.env.REACT_APP_SSO_LOGIN_URL}
                        component={ApplicationLayout}
                      />
                    )}
                  />
                </RouterRoutes>
              </BrowserRouter>
            </Provider>
          </ThemeProvider>
        </StyledEngineProvider>
      </LocalizationProvider>
    );
  }
}

export default withSSO({ redirectUrl: process.env.REACT_APP_SSO_LOGIN_URL })(App);
